export type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never}[keyof T];

export const distinctFilter = <T>(value: T, index: number, self: T[]): boolean => self.indexOf(value) === index;
